module.exports = __webpack_public_path__ + "foot_logo.66f86225.png";